import React from 'react';
import { BubbleButton } from './BubbleUI';

import './StaffConflictsPanel.scss';
import { StaffWarning } from '@go-shared/types/staffAllocation';
import { DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT, timeToString } from '@go-shared/lib/time';

export interface StaffConflictsPanelProps {
  open: boolean;
  width: number;
  venueWarnings: StaffWarning[];
  onSetShowStaffConflictsPanelClick: (show: boolean) => void;
}

function StaffConflictsPanel(props: StaffConflictsPanelProps) {
  const { open, width } = props;

  return (
    <div
      className={`StaffConflictsPanel absolute top-0 left-0 w-full flex flex-col bg-eggshell border-r ${
        open ? 'open' : ''
      }`}
      style={{ width }}
    >
      <div className="StaffConflictsPanelList flex-shrink-0 flex items-stretch bg-banana">
        <span className="mx-3 font-bold uppercase text-white self-center">STAFF CONFLICTS</span>
        <BubbleButton
          variant="white"
          inverse
          className="ml-auto"
          onClick={() => props.onSetShowStaffConflictsPanelClick(false)}
          icon="xmark"
        />
      </div>
      <div className="flex-grow overflow-y-scroll">
        {props.venueWarnings.map((m, i) => (
          <div className="bg-white p-4 border-b" key={i}>
            <h4 className="font-bold uppercase text-navy">
              {m.eventName} at{' '}
              {timeToString(m.eventStart, DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT)}
            </h4>
            <h5 className="italic mb-1">{m.venueName}</h5>
            <p className="text-slate">
              {m.template.title} is assigned at the same time in multiple events
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StaffConflictsPanel;
